import { primary } from "@/styles/variable"
import styled from "styled-components"

interface IMySessionTagContainerProps {
  color?: string
  radius?: string
}

export const MySessionTagContainer = styled.button<IMySessionTagContainerProps>`
  display: inline-flex;
  flex-wrap: wrap;
  padding: 0px 10px;
  align-items: center;
  gap: 4px;
  border: none;
  outline: none;
  height: 25px;
  cursor: pointer;
  border-radius: 30px;
  background-color: ${props => props.color};
  &.active {
    background: ${primary.black};
    span {
      color: ${primary.white}!important;
    }
  }
`

export const MySessionTagTitle = styled.span`
  color: ${primary.black};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const MySessionTagIcon = styled.img`
  display: flex;
  width: 8px;
  height: 8px;
  object-fit: contain;
  align-items: center;
  gap: 4px;
`
